import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import { Form, Formik } from 'formik';
import {
  ShopHeroWidgetFields,
  ShopHeroWidgetFormFields,
} from 'components/consumer-page-widgets/shop-hero-widget/ShopHeroWidgetFormFields';
import { consumer } from '@tock/coretypes';
import {
  getBaseFormFieldsInitialValues,
  useUpdateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface UpdateShopHeroWidgetFormProps {
  selectedWidgetToEdit?: consumer.NamedConfiguration;
  onCompleteOrCancel(): void;
}

export const UpdateShopHeroWidgetForm: FunctionComponent<
  React.PropsWithChildren<UpdateShopHeroWidgetFormProps>
> = ({ selectedWidgetToEdit, onCompleteOrCancel }) => {
  const updateNamedConfig = useUpdateNamedConfigurations();

  if (!selectedWidgetToEdit?.shopHeroWidgetConfig) {
    return null;
  }

  const handleSubmit = ({
    leftImageAlt,
    leftImageUrl,
    rightImageAlt,
    rightImageUrl,
    bodyText,
    linkText,
    linkHref,
  }: ShopHeroWidgetFields) => {
    return updateNamedConfig({
      ...selectedWidgetToEdit,
      shopHeroWidgetConfig: {
        shopHeroImage: [
          { imageAlt: leftImageAlt, imageUrl: leftImageUrl },
          { imageAlt: rightImageAlt, imageUrl: rightImageUrl },
        ],
        bodyText,
        linkText,
        linkHref,
      },
    }).then(onCompleteOrCancel);
  };

  const { bodyText, linkText, linkHref, shopHeroImage } = selectedWidgetToEdit.shopHeroWidgetConfig;

  return (
    <>
      <Typography variant="heading1Bold">Editing widget: {selectedWidgetToEdit.name}</Typography>
      <Formik<ShopHeroWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues({ widgetToEdit: selectedWidgetToEdit }),
          leftImageAlt: shopHeroImage?.[0].imageAlt ?? '',
          leftImageUrl: shopHeroImage?.[0].imageUrl ?? '',
          rightImageAlt: shopHeroImage?.[1].imageAlt ?? '',
          rightImageUrl: shopHeroImage?.[1].imageUrl ?? '',
          bodyText: bodyText ?? '',
          linkText: linkText ?? '',
          linkHref: linkHref ?? '',
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <ShopHeroWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button onClick={onCompleteOrCancel} type="button" variant="outlined">
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
